import { StoryReaderPage } from './StoryReaderPage'
import { withStoryReaderPage } from './withStoryReaderPage'

const Connected = withStoryReaderPage(StoryReaderPage)

export { Connected as StoryReaderPage }
